import React from 'react';

import { useProjectStatsQuery } from 'src/app/admin/state/api/adminGraphSlice';
import StatsPanel from 'src/app/admin/components/stats-panel/StatsPanel';
import GeneratedAtLabel from 'src/app/admin/components/stats-panel/GeneratedAtLabel';

type ProjectStatsPanelProps = {
    projectId: string;
    /** Aggregates are not worth computing for a panel nobody is looking at — a shut drawer, say. */
    skip?: boolean;
};

/**
 * What a project owns, as the organisation panel does for a customer. Everything listed here is
 * what a delete would take with it, which is why the counts are worth showing before one is offered.
 */
const ProjectStatsPanel = ({ projectId, skip = false }: ProjectStatsPanelProps) => {
    const { data: stats, isLoading, isError } = useProjectStatsQuery({ projectId }, { skip });

    return (
        <section className='flex flex-col gap-3' data-testid='project-stats-panel'>
            <StatsPanel
                title='What this project owns'
                isLoading={isLoading}
                isError={isError}
                figures={[
                    { label: 'Samples', value: stats?.sampleCount ?? 0 },
                    { label: 'Assets', value: stats?.assetCount ?? 0 },
                    { label: 'Charts', value: stats?.chartCount ?? 0 },
                ]}
            />

            <GeneratedAtLabel generatedAt={stats?.generatedAt} />
        </section>
    );
};

export default ProjectStatsPanel;
